/**
 * Prefijo del CUFE.
 *
 * Un CUFE de la DGI son 66 caracteres que empiezan con `FE`. Dentro del portal
 * se guarda SIN el prefijo (64 caracteres), que es como lo devuelve la API en el
 * campo `cufe` de una factura, y el prefijo se agrega al mostrarlo y al armar el
 * payload.
 *
 * Estas dos funciones son el único lugar donde se decide eso. Antes la regla
 * estaba repartida en cuatro: el input lo quitaba, el efecto del formulario lo
 * ponía, y dos vistas lo agregaban por su cuenta — así un CUFE que ya venía con
 * prefijo terminaba con `FEFE`.
 */

const PREFIJO = 'FE';

/** Sin el prefijo: la forma en que se guarda dentro del portal (64 caracteres). */
export function cufeSinPrefijo(cufe: string | null | undefined): string {
  const valor = (cufe ?? '').trim();
  return valor.startsWith(PREFIJO) ? valor.slice(PREFIJO.length) : valor;
}

/**
 * Con el prefijo: la forma canónica de la DGI (66 caracteres), para mostrar y
 * para enviar. Devuelve cadena vacía si no hay CUFE, para no mostrar un `FE`
 * suelto cuando el campo está vacío.
 */
export function cufeConPrefijo(cufe: string | null | undefined): string {
  const base = cufeSinPrefijo(cufe);
  return base ? PREFIJO + base : '';
}
